import React from 'react';
import { Paper, Grid, Typography, Box } from '@mui/material';
import globals from '../../globals.js';

{/* About us */ }
const WhoWeAre = () => {
    return (
<Grid container sx={{ mt: 10 }} justifySelf={'center'}>
    <Paper square elevation={3} sx={{ px: 3, bgcolor: globals.colors.lightRed, width: '100%' }}>
        <Grid container sx={{ mt: 3 }}>
            <Grid item xs={12} sm={6} display="flex" direction={'column'}>
                <Typography variant='h2' sx={{ color: globals.colors.backgroundColor, fontWeight: 'bold', fontSize: 35, textTransform: 'uppercase', textShadow: '3px 3px 5px rgba(0, 0, 0, 0.5)', }}>Кои сме ние?</Typography>
                <Typography sx={{ color: globals.colors.backgroundColor, fontSize: 20, mt: 2, textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', }}><Box component="b">eAcademiaBg</Box> е <Box component="b">иновативна образователна платформа</Box>, която предлага <Box component="b">онлайн уроци</Box> с акцент върху <Box component="b">интересите на учениците</Box> – в малки групи или <Box component="b">индивидуално
                    с опитни учители.</Box></Typography>
                <Typography variant='h2' sx={{ color: globals.colors.backgroundColor, fontWeight: 'bold', fontSize: 35, textTransform: 'uppercase', mt: 5, textShadow: '3px 3px 5px rgba(0, 0, 0, 0.5)', }}>Цел и Мисия</Typography>
                <Typography sx={{ color: globals.colors.backgroundColor, fontSize: 20, mt: 2, textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', }}>Искаме да <Box component="b">обединяваме ученици и учители</Box> от различни възрасти и места в България чрез <Box component="b">обмяна на знания и умения,</Box> като в същото време <Box component="b">вдъхновяваме и предизвикаваме интерес към ученето.</Box></Typography>
            </Grid>
            <Grid item display="flex" size={{ xs: 10, sm: 5 }} width={{ xs: 1, md: 0.5 }}>
                <img 
                alt= "Илюстрация на сова с академическа шапка и текст за мисията на eAcademiaBg"
                title="Кои сме ние и нашата мисия – eAcademiaBg"
                src='eacademiabg-koi-sme-nie-tsel-misiya.webp' loading="lazy" decoding="async" style={{ overflow: 'hidden', maxWidth: "100%", height: "auto" }}></img>
            </Grid>
        </Grid>
    </Paper>
</Grid>
    );
}
export default WhoWeAre;